const COLOR_SCHEME_COOKIE = "color_scheme";

export default {
    isDarkMode : false,

    /**
     * Initiates the color scheme
     */
    init() {
        this.isDarkMode =  this.getCookie( COLOR_SCHEME_COOKIE ) ? ( this.getCookie( COLOR_SCHEME_COOKIE ) == "dark" )  : window.matchMedia("(prefers-color-scheme: dark)").matches;
        if( this.isDarkMode ) this.setDarkClass();
    },
    /**
     * Activates Dark Mode
     */
    activateDarkMode() {
        this.isDarkMode = true;
        this.setDarkClass();
        this.setCookie( COLOR_SCHEME_COOKIE, "dark", 1 );
    },
    /**
     * Deactivates Dark Mode
     */
    deactivateDarkMode() {
        this.isDarkMode = false;
        this.unsetDarkClass();
        this.setCookie( COLOR_SCHEME_COOKIE, "light", 5 );
    },
    /**
     * Gets Cookie
     * @param {String} name - The name of cookie
     */
    getCookie( name ) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';' );
        for ( var i = 0; i < ca.length; i++ ) {
          var c = ca[ i ];
          while ( c.charAt( 0 ) == ' ' ) c = c.substring( 1, c.length );
          if ( c.indexOf( nameEQ ) == 0 ) return c.substring( nameEQ.length, c.length );
        }
        return null;
    },
    /**
     * Sets Cookie
     * @param {String} name - The name of cookie
     * @param {String} value - The value of cookie
     * @param {Number} days - The number of days before exiration
     */
    setCookie( name, value, days ) {
        var expires = "";
        if ( days ) {
          var date = new Date();
          date.setTime( date.getTime() + ( days * 24 * 60 * 60 * 1000 ) );
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + ( value || "") + expires + "; path=/";
    },
    /**
     * Adds dark mode class to the body
     */
    setDarkClass() {
        document.querySelector( "body" ).classList.add( "dark-mode" );
    },
    /**
     * Removes dark mode class from the body
     */
    unsetDarkClass() {
        document.querySelector( "body" ).classList.remove( "dark-mode" );
    },
    /**
     * Toggles Dark Mode
     */
    toggleDarkMode() {
        if( this.isDarkMode ){
            this.deactivateDarkMode();
        } else {
            this.activateDarkMode();
        }
    }
};